import { AxiosResponse } from 'axios';

import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';
import { env } from '../../env';
import { Patient } from '../../features/settings/types';

interface HouseholdMemberResponse extends APIResponseStatus {
  resource: fhir4.Patient;
}

interface SearchResponse extends APIResponseStatus {
  resource: {
    resourceType: string;
    type: string;
    entry: Array<{ resource: fhir4.Person }>;
    total?: string | number;
  };
}

class HouseholdMemberService {
  static async getHouseholdMembers(
    uuid: string = '00000000-0000-0000-0000-000000000000',
    accessToken: string,
  ) {
    const res = await API.get<any, AxiosResponse<{ resource: Patient }>>(
      `${env.REACT_APP_API_BASE_URL}/v1/resources/Patient/${uuid}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return res.data.resource.household;
  }

  static async addHouseholdMember(params: any, accessToken: string) {
    const res = await API.post<any, AxiosResponse<APIResponseStatus>>(
      `${env.REACT_APP_API_BASE_URL}/v1/resources/Patient/Household/Member/Invitation`,
      params,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return res.data;
  }

  static async updateHouseholdMember(params: any, accessToken: string) {
    const res = await API.request<any, AxiosResponse<APIResponseStatus>>({
      method: 'PATCH',
      url: `${env.REACT_APP_API_BASE_URL}/v1/resources/Patient/Household/Member`,
      data: params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res.data;
  }

  static async updatePatient(params: any, accessToken: string) {
    const res = await API.post<any, AxiosResponse<HouseholdMemberResponse>>(
      `${env.REACT_APP_API_BASE_URL}/v1/resources/Patient`,
      params,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return res.data.resource;
  }

  static async search(params: any, accessToken: string) {
    const res = await API.post<any, AxiosResponse<SearchResponse>>(
      `${env.REACT_APP_API_BASE_URL}/v1/resources/Person/_search`,
      params,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return res.data.resource;
  }
}

export default HouseholdMemberService;
